import axios from 'axios';

var getBaseURL = function () {
  var lang = document.getElementsByTagName('html')[0].lang;
  return '/' + lang + '/api/v1';
}

const ax = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'X-Requested-with': 'XHR'
  },
  validateStatus: function (status) {
    return status < 500; // Reject only if the status code is greater than or equal to 500
  }
});

class DataService {
  request(method, options) {
    return ax({
      method: method,
      url: options.url,
      data: options.data,
      params: options.params,
      withCredentials: true
    }).then(res => {
      const data = res.data;
      if(!this.vuexStore) {
        return data;
      }

      if(data.code === 401) {
        this.vuexStore.commit('setLoginStatus', false);
      }

      if(data.code === 200 && data.messages.length) {
        this.vuexStore.commit('addNotification', data.messages);
      }

      return data;

    }).catch(function (error) {
      if(error.response) {
        const data = error.response.data;
        console.error(`Server error status: ${data.code}\n${data.result.error.stack}`);
      }
    });
  }

  /**
   * If you're using dataService this with vuex, we can automatically logout user and do other stuff based on responses
   *
   * @param {Object} store - vuex store object
   */
  setVuexStore(store) {
    this.vuexStore = store;
  }

  get(path, params) {
    return this.request('get', {
      url: path,
      params: params
    });
  }
  post(path, data, params, config) {
    return this.request('post', {
      url: path,
      data: data,
      params: params,
      config: config
    });
  }
  patch(path, data, params) {
    return this.request('patch', {
      url: path,
      data: data,
      params: params
    });
  }
  put(path, data, params) {
    return this.request('put', {
      url: path,
      data: data,
      params: params
    });
  }
  delete(path, params) {
    return this.request('delete', {
      url: path,
      params: params
    });
  }
}

export default new DataService();
